import { useState } from 'react';
import { Form, Input, Select, Button, Card, Row, Col, Alert, Space, Typography } from 'antd';
import { SaveOutlined, ReloadOutlined, PlusOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import AdminSidebar from '../Components/Sidebar';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { createSubServices } from '../redux/slices/servicesSlice';

const { Title } = Typography;

function CreateSubServices() {
    const { state } = useLocation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const dispatch = useDispatch();

    const handleReset = () => {
        form.resetFields();
        setAlertMessage('');
    };

    const onFinish = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(createSubServices({
                name: values.name,
                specialized_service_id: state?.id,
                status: Number(values?.status) ?? 1
            }));

            if (createSubServices.fulfilled.match(resultAction)) {
                form.resetFields();
                setAlertMessage(resultAction?.payload?.message || 'Sub service created successfully!');
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            } else {
                setAlertMessage(resultAction?.payload?.error || 'Failed to create sub service');
                setAlertType('error');
            }

        } catch (error) {
            setAlertMessage('Failed to create sub service');
            setAlertType('error');
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AdminSidebar renderContent={
                <div>
                    <Card
                        title={
                            <Title level={3} style={{ margin: 0 }}>
                                <PlusOutlined style={{ marginRight: 8, color: '#CA9AE8' }} />
                                Create Sub Service
                            </Title>
                        }
                        style={{
                            marginBottom: 24,
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                            border: 'none',
                        }}
                    >
                        {alertMessage && (
                            <Alert
                                message={alertMessage}
                                type={alertType}
                                showIcon
                                icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                                closable
                                onClose={() => setAlertMessage('')}
                                style={{
                                    marginBottom: 24,
                                    borderRadius: '8px',
                                }}
                            />
                        )}

                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onFinish}
                            autoComplete="off"
                            size="large"
                        >
                            <Row gutter={[24, 0]}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Form.Item
                                        label={
                                            <span style={{ fontSize: '15px', fontWeight: 500 }}>
                                                Service Name
                                            </span>
                                        }
                                        name="name"
                                        rules={[
                                            { required: true, message: 'Please enter service name' },
                                            { min: 2, message: 'Service name must be at least 2 characters' },
                                            { max: 100, message: 'Service name must not exceed 100 characters' }
                                        ]}
                                    >
                                        <Input
                                            placeholder="Enter service name"
                                            prefix={<PlusOutlined style={{ color: '#CA9AE8' }} />}
                                            style={{
                                                borderRadius: '8px',
                                                padding: '8px 12px',
                                            }}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Form.Item
                                        label={
                                            <span style={{ fontSize: '15px', fontWeight: 500 }}>
                                                Status
                                            </span>
                                        }
                                        name="status"
                                        rules={[
                                            { required: true, message: 'Please select status' }
                                        ]}
                                        initialValue="1"
                                    >
                                        <Select
                                            placeholder="Select Status"
                                            optionFilterProp="label"
                                            style={{
                                                borderRadius: '8px',
                                            }}
                                            options={[
                                                {
                                                    value: '1',
                                                    label: (
                                                        <Space>
                                                            <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                                            Active
                                                        </Space>
                                                    )
                                                },
                                                {
                                                    value: '0',
                                                    label: (
                                                        <Space>
                                                            <CloseCircleOutlined style={{ color: '#ff4d4f' }} />
                                                            Inactive
                                                        </Space>
                                                    )
                                                },
                                            ]}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24}>
                                    <Form.Item style={{ marginTop: 8, marginBottom: 0 }}>
                                        <Space size="middle">
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                icon={<SaveOutlined />}
                                                loading={loading}
                                                size="large"
                                                style={{
                                                    backgroundColor: '#CA9AE8',
                                                    borderColor: '#CA9AE8',
                                                    borderRadius: '8px',
                                                    paddingLeft: '32px',
                                                    paddingRight: '32px',
                                                    height: '42px',
                                                    fontSize: '15px',
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Create Service
                                            </Button>
                                            <Button
                                                htmlType="button"
                                                icon={<ReloadOutlined />}
                                                onClick={handleReset}
                                                size="large"
                                                style={{
                                                    borderRadius: '8px',
                                                    paddingLeft: '32px',
                                                    paddingRight: '32px',
                                                    height: '42px',
                                                    fontSize: '15px',
                                                }}
                                            >
                                                Reset
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </div>
            } />
        </>
    );
}

export default CreateSubServices;
